<div class="dealer-popup-overlay" *ngIf="visible" (click)="onClose()">
  <div class="dealer-popup" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="dealer-popup-header">
      <div class="dealer-popup-header-title">
        <div class="details-card-icon">
          <i class="fas" [ngClass]="mode === 'create' ? 'fa-user-plus' : 'fa-user-edit'"></i>
        </div>
        <h3>{{ title }}</h3>
      </div>
      <button type="button" class="fn-action-btn" (click)="onClose()" title="Chiudi">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="dealer-popup-body">

      <!-- Errore -->
      <div class="dealer-popup-error" *ngIf="errorMessage">
        <i class="fas fa-exclamation-triangle"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <!-- Cliente / Marchio -->
      <div class="filter-group">
        <h6 class="filter-group-title">Cliente & Marchio</h6>
        <div class="filter-group-body">
          <div class="details-grid">
            <div class="details-item">
              <label class="details-label">Cliente *</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-user filter-icon"></i>
                <select class="filter-select"
                        [(ngModel)]="form.dealerClientCode"
                        (ngModelChange)="onClientChange()"
                        [disabled]="mode === 'edit'">
                  <option value="">Seleziona cliente</option>
                  <option *ngFor="let c of filteredClientsBrands" [value]="c.clientCode">
                    {{ c.clientName || c.clientCode }}
                  </option>
                </select>
              </div>
            </div>

            <div class="details-item">
              <label class="details-label">Marchio *</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-tag filter-icon"></i>
                <select class="filter-select"
                        [(ngModel)]="form.dealerBrandCode"
                        [disabled]="mode === 'edit' || !form.dealerClientCode">
                  <option value="">Seleziona marchio</option>
                  <option *ngFor="let b of availableBrands" [value]="b.brandCode">
                    {{ b.brandName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Dati Principali -->
      <div class="filter-group">
        <h6 class="filter-group-title">Dati Principali</h6>
        <div class="filter-group-body">
          <div class="details-grid">
            <div class="details-item">
              <label class="details-label">
                Codice Dealer
                <span *ngIf="dealerCodeRequired">*</span>
              </label>
              <div class="filter-input-wrapper">
                <i class="fas fa-user-tie filter-icon"></i>
                <input type="text" class="filter-input"
                       [(ngModel)]="form.dealerCode"
                       [disabled]="!dealerCodeEnabled"
                       [placeholder]="dealerCodePlaceholder"
                       maxlength="50"
                       autocomplete="off">
              </div>
            </div>

            <div class="details-item">
              <label class="details-label">Ragione Sociale *</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-building filter-icon"></i>
                <input type="text" class="filter-input"
                       [(ngModel)]="form.dealerName"
                       (input)="onDealerNameInput($event)"
                       placeholder="Nome o ragione sociale"
                       maxlength="255"
                       autocomplete="off">
              </div>
            </div>

            <div class="details-item">
              <label class="details-label">Partita IVA</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-receipt filter-icon"></i>
                <input type="text" class="filter-input"
                       [(ngModel)]="form.dealerVatNumber"
                       placeholder="Partita IVA"
                       maxlength="16"
                       autocomplete="off"
                       (input)="form.dealerVatNumber = $any($event.target).value.toUpperCase()">
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Indirizzo Operativo -->
      <div class="filter-group">
        <h6 class="filter-group-title">Indirizzo Operativo</h6>
        <div class="filter-group-body">
          <div class="address-grid">
            <!-- Riga 1: Via, Numero, CAP -->
            <div class="details-item">
              <label class="details-label">Via *</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-road filter-icon"></i>
                <input type="text" class="filter-input"
                       [(ngModel)]="form.dealerOperatingAddressStreet"
                       placeholder="Via"
                       maxlength="150"
                       autocomplete="off">
              </div>
            </div>

            <div class="details-item">
              <label class="details-label">Numero</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-hashtag filter-icon"></i>
                <input type="text" class="filter-input"
                       [(ngModel)]="form.dealerOperatingAddressNumber"
                       placeholder="Numero civico"
                       maxlength="10"
                       autocomplete="off">
              </div>
            </div>

            <div class="details-item">
              <label class="details-label">CAP *</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-mail-bulk filter-icon"></i>
                <input type="text" class="filter-input"
                       [(ngModel)]="form.dealerOperatingAddressZip"
                       placeholder="CAP"
                       maxlength="5"
                       pattern="[0-9]{5}"
                       inputmode="numeric"
                       autocomplete="off">
              </div>
            </div>

            <!-- Riga 2: Città, Provincia, Paese -->
            <div class="details-item">
              <label class="details-label">Città *</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-city filter-icon"></i>
                <input type="text" class="filter-input"
                       [(ngModel)]="form.dealerOperatingAddressCity"
                       placeholder="Città"
                       maxlength="100"
                       autocomplete="off">
              </div>
            </div>

            <div class="details-item">
              <label class="details-label">Provincia *</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-map filter-icon"></i>
                <input type="text" class="filter-input"
                       [(ngModel)]="form.dealerOperatingAddressProvince"
                       placeholder="es. MI"
                       maxlength="2"
                       autocomplete="off"
                       (input)="form.dealerOperatingAddressProvince = $any($event.target).value.toUpperCase()">
              </div>
            </div>

            <div class="details-item">
              <label class="details-label">Paese</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-flag filter-icon"></i>
                <input type="text" class="filter-input"
                       [(ngModel)]="form.dealerOperatingAddressCountry"
                       disabled
                       placeholder="IT">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="dealer-popup-footer">
      <button type="button" class="fn-action-btn-wide"
              (click)="onClose()"
              [disabled]="submitting">
        <i class="fas fa-times"></i>
        <span>Annulla</span>
      </button>
      <button type="button" class="fn-action-btn-wide fn-action-btn-wide--primary"
              (click)="onSubmit()"
              [disabled]="submitting">
        <i class="fas" [ngClass]="submitting ? 'fa-spinner fa-spin' : (mode === 'create' ? 'fa-plus' : 'fa-save')"></i>
        <span>{{ submitLabel }}</span>
      </button>
    </div>

  </div>
</div>
